export default __webpack_public_path__ + "static/media/voucher_member.8e5fc272.csv";